import { gql, TypedDocumentNode } from "@apollo/client";

import { Plugin } from "types/generated";

export const GET_PLUGINS: TypedDocumentNode<{ plugins: Array<Plugin> }> = gql`
  query GetPlugins {
    plugins {
      createdAt
      description
      id
      labelIdentifier
      labels
      manifest
      name
      updatedAt
      slug
      pluginTemplateDetails {
        id
        name
      }
      spaceDetails {
        id
        name
        accessLevel
      }
    }
  }
`;

export const DELETE_PLUGIN: TypedDocumentNode<{ pluginDelete: { id: string } }> = gql`
  mutation DeletePlugin($id: ID!) {
    pluginDelete(id: $id) {
      id
    }
  }
`;
